import Loading from "components/common/Loading";
import { useHttpUtil } from "context/HttpContext";
import { useEffect, useRef, useState } from "react"
import CustomImage from "components/common/CustomImage";

type ProductLib = {
    id : string,
    name: string,
    url : string,
    product: boolean,
    sonList ?: ProductLib[]
}

// Shopify 产品
export default function Product(props: { onImageClick: Function, type?: number}){
    const {type = 1} = props ;

    const [ list, setList] = useState<ProductLib[]>([]);
    const [ showList, setShowList] = useState<ProductLib[]>();
    const [ isLoading, setIsLoading ]= useState<boolean>(false);
    const [ parents, setParents ]= useState<ProductLib[]>([]);
    const [ currentPage, setCurrentPage ]= useState<number>(1);
    const [ isEnd, setIsEnd ]= useState<boolean>(false);

    const listElement = useRef<HTMLDivElement>(null);

    const httpUtil = useHttpUtil();
    

    useEffect(() => {
        initList();
    }, [ currentPage ])

    const initList = async () => {
        if(isEnd) return ;
        setIsLoading(true);
        const resData = await httpUtil.post('/biz/product/list',{
            type,
            currentPage: currentPage
        });
        if(resData.errCode === 0){
            let _temp = resData.data;
            if(!_temp.length && currentPage > 1){
                setIsEnd(true);
            }
            if(currentPage > 1){
                _temp = [...list].concat(_temp);
            }
            setList(_temp)
            setShowList(_temp)
        }
        setIsLoading(false);
    }

    const changeProduct = async (p: ProductLib) => {
        if(p.product){
            props.onImageClick(p.url);
            await httpUtil.post('/biz/product/click',{ productId: p.id});
            return
        }
        const _temp = [...parents];
        _temp.push(p);
        setParents(_temp);
        setShowList(p.sonList);

        listElement.current && listElement.current.scrollTo({
            top: 0
        })
    }

    const changeLayer = (index: number = -1) => {
        if(index === -10000){
            setParents([]);
            setShowList([...list]);
            return ;
        }
        index = index == -1 ? parents.length - 2 : index ;
        const _temp = {...parents[index]};
        const _tempParents = [...parents];
        _tempParents.splice(index + 1, parents.length - index);
        setParents(_tempParents);
        if(_tempParents.length) setShowList(_temp.sonList)
        else setShowList([...list])
    }

    const scrollContent = async function () {
        if(parents.length || isEnd) return ;
        if(listElement.current && currentPage > 0 && !isLoading){
            const { scrollTop, scrollHeight, clientHeight} = listElement.current ;
            if(scrollTop + clientHeight + 20 > scrollHeight){
                setCurrentPage(currentPage + 1)
            }
        }
    }

    return (
        <div className="absolute z-[10001] h-full top-[0px] shadow-lg bg-[#FFFFFF] xl:w-[320px] xl:left-[100px] w-[200px] left-[70px]">
            <div ref={listElement} className="relative flex flex-col h-full w-full p-[10px] xl:p-[20px] overflow-y-auto z-[10001]  bg-[#FFFFFF]"
                onScroll={() => scrollContent()}>
                {
                    parents.length == 0 ?
                        <p className="medium-txt font-medium">{ type == 1 ? 'Product mockups categories' : 'Pattern mockups categories'}</p>
                    :
                    <div className="relative pl-[40px] pr-[20px]">
                        <CustomImage src="/icon/icon-left.png" className="absolute left-0 top-[1px] w-[20px] cursor-pointer" 
                            onClick={() => changeLayer()}/>
                        <span className=" medium-txt"><span className="cursor-pointer" onClick={() => changeLayer(-10000)}>Catalog</span> 
                        {
                            parents.map((p,index) => (<span className="cursor-pointer" key={p.id} onClick={() => changeLayer(index)}> / {p.name}</span>))
                        }
                        </span>
                    </div>
                }
                <div className="grid grid-cols-2 gap-[5px] xl:gap-[10px] mt-[5px] xl:mt-[10px]">
                    {
                        showList && showList.map((product: ProductLib) => (
                            <div className="cursor-pointer border rounded-[10px]" key={product.id} onClick={() => { changeProduct(product)}}>
                                <div className="aspect-square flex items-center justify-center]">
                                    <CustomImage src={product.url || "/no-image.png"} className={`max-w-full max-h-full ${product.product ? 'rounded-[10px]' : 'rounded-t-[10px]'}`} />
                                </div>
                                {
                                    !product.product && 
                                    <div className="flex items-center p-[10px]" >
                                        <span className="font-semibold truncate small-txt">{product.name}</span>
                                    </div>
                                }
                            </div>
                        ))
                    }
                </div>
                {
                    isLoading &&
                        <div className="mt-[80px] text-center">
                            <Loading className="!pb-[5px]"/>
                            <p>Loading, please wait...</p>
                        </div>
                }
            </div>
        </div>
    )
}